/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseRichTextBlockFragment, RichTextBlockFragment, FullRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block';

/**
 * Get a single RichTextBlock by ID (base - scalars only)
 */
export const getBaseRichTextBlockById = gql`
  ${BaseRichTextBlockFragment}

  query GetBaseRichTextBlockById($id: String!, $locale: String!, $preview: Boolean) {
    richTextBlock(id: $id, locale: $locale, preview: $preview) {
      ...BaseRichTextBlockFragment
    }
  }
`;

/**
 * Get a single RichTextBlock by ID (standard - 1 level deep)
 */
export const getRichTextBlockById = gql`
  ${RichTextBlockFragment}

  query GetRichTextBlockById($id: String!, $locale: String!, $preview: Boolean) {
    richTextBlock(id: $id, locale: $locale, preview: $preview) {
      ...RichTextBlockFragment
    }
  }
`;

/**
 * Get a single RichTextBlock by ID (full - 2 levels deep)
 */
export const getFullRichTextBlockById = gql`
  ${FullRichTextBlockFragment}

  query GetFullRichTextBlockById($id: String!, $locale: String!, $preview: Boolean) {
    richTextBlock(id: $id, locale: $locale, preview: $preview) {
      ...FullRichTextBlockFragment
    }
  }
`;

/**
 * Get all RichTextBlock entries with pagination (base - scalars only)
 */
export const getBaseRichTextBlocks = gql`
  ${BaseRichTextBlockFragment}

  query GetBaseRichTextBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [RichTextBlockOrder]
    $where: RichTextBlockFilter
    $preview: Boolean
  ) {
    richTextBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseRichTextBlockFragment
      }
    }
  }
`;

/**
 * Get all RichTextBlock entries with pagination (standard - 1 level deep)
 */
export const getRichTextBlocks = gql`
  ${RichTextBlockFragment}

  query GetRichTextBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [RichTextBlockOrder]
    $where: RichTextBlockFilter
    $preview: Boolean
  ) {
    richTextBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...RichTextBlockFragment
      }
    }
  }
`;

/**
 * Get all RichTextBlock entries with pagination (full - 2 levels deep)
 */
export const getFullRichTextBlocks = gql`
  ${FullRichTextBlockFragment}

  query GetFullRichTextBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [RichTextBlockOrder]
    $where: RichTextBlockFilter
    $preview: Boolean
  ) {
    richTextBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullRichTextBlockFragment
      }
    }
  }
`;
